<template>
  <div>
    <transition name="fade" mode="out-in">
      <div>
        <h1 class="title mqu-subtitle">Review and Compare Results</h1>
        <article class="notification is-light">
          <p class="subtitle is-5">The table below shows the results for your last three contracts.</p>
          <table class="table">
            <thead>
              <tr>
                <th>Monthly Rent</th>
                <th>{{list[0].data.propertyDetails.unitNumber + " - " + list[0].data.propertyDetails.villageName}}</th>
                <th v-if="length > 1">{{list[1].data.propertyDetails.unitNumber + " - " + list[1].data.propertyDetails.villageName}}</th>
                <th v-if="length > 2">{{list[2].data.propertyDetails.unitNumber + " - " + list[2].data.propertyDetails.villageName}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th><strong>Average Term</strong></th>
                <th><strong>{{list[0].response.expected_healthy_lifespan_year_rent_per_month | currency}}</strong></th>
                <th v-if="length > 1"><strong>{{list[1].response.expected_healthy_lifespan_year_rent_per_month | currency}}</strong></th>
                <th v-if="length > 2"><strong>{{list[2].response.expected_healthy_lifespan_year_rent_per_month | currency}}</strong></th>
              </tr>
              <tr>
                <th>2 Year Term</th>
                <th>{{list[0].response.two_year_rent_per_month | currency}}</th>
                <th v-if="length > 1">{{list[1].response.two_year_rent_per_month | currency}}</th>
                <th v-if="length > 2">{{list[2].response.two_year_rent_per_month | currency}}</th>
              </tr>
              <tr>
                <th>5 Year Term</th>
                <th>{{list[0].response.five_year_rent_per_month | currency}}</th>
                <th v-if="length > 1">{{list[1].response.five_year_rent_per_month | currency}}</th>
                <th v-if="length > 2">{{list[2].response.five_year_rent_per_month | currency}}</th>
              </tr>
              <tr>
                <th>10 Year Term</th>
                <th>{{list[0].response.ten_year_rent_per_month | currency}}</th>
                <th v-if="length > 1">{{list[1].response.ten_year_rent_per_month | currency}}</th>
                <th v-if="length > 2">{{list[2].response.ten_year_rent_per_month | currency}}</th>
              </tr>
              <tr>
                <th>20 Year Term</th>
                <th>{{list[0].response.twenty_year_rent_per_month | currency}}</th>
                <th v-if="length > 1">{{list[1].response.twenty_year_rent_per_month | currency}}</th>
                <th v-if="length > 2">{{list[2].response.twenty_year_rent_per_month | currency}}</th>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['value'],
  components: {},
  data() {
    return {
      list: this.value.list,
      length: this.value.length
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/Review.vue